import React, { useContext } from "react";
import classnames from "classnames";
import { SwitchButtonItemProps } from "./interface";

import SwitchButtonContext from "./SwitchButtonContext";

const SwitchButtonItem: React.FC<SwitchButtonItemProps> = (props) => {
  const {
    id,
    active,
    defaultIconUrl,
    activeIconUrl,
    title,
    onClick,
    className,
    style,
  } = props;

  const prefixCls = "switch-button__item";

  const classes = classnames(
    prefixCls,
    {
      "is-active": !!active,
    },
    className
  );

  /* useContext */
  const { currentItemRef } = useContext(SwitchButtonContext);

  return (
    <div
      className={classes}
      style={style}
      onClick={onClick}
      ref={active ? currentItemRef : undefined}
    >
      <div className={`${prefixCls}-icon`}>
        {!!defaultIconUrl && (
          <img
            className={`${prefixCls}-icon-img is-default`}
            src={defaultIconUrl}
          />
        )}
        {!!activeIconUrl && (
          <img
            className={`${prefixCls}-icon-img is-active`}
            src={activeIconUrl}
          />
        )}
      </div>
      {!!title && <div className={`${prefixCls}-tit`}>{title}</div>}
    </div>
  );
};
SwitchButtonItem.defaultProps = {};

export default SwitchButtonItem;
